import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from "../axiosBaseQuery";
import { IPredectivePayload } from "../../interface/IHome";
import { InventoryGraphPayload } from '../../interface/IAlerts';
import { IDemandPayload } from '../../interface/IDemand';

export const inventoryApi = createApi({
  reducerPath: 'inventoryApi',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getInventoryFilters: builder.mutation({
        query: (payload: IPredectivePayload) => ({
            url: "/getInventoryFilters",
            method: 'POST',
            data: payload,
        }),
    }),
    getPotentialOverstockData: builder.mutation({
        query: (payload: any) => ({
            url: "/getPotentialOverstockData",
            method: 'POST',
            data: payload,
        }),
    }),
    getStockoutData: builder.mutation({
        query: (payload: any) => ({
            url: "/getStockoutData",
            method: 'POST',
            data: payload,
        }),
    }),
    getDemandInventoryLineGraphData: builder.mutation({
        query: (payload: InventoryGraphPayload) => ({
            url: "/getDemandInventoryLineGraphData",
            method: 'POST',
            data: payload,
        }),
    }),
    getPotentialOverstockLineGraphData: builder.mutation({
        query: (payload: InventoryGraphPayload)=>({
            url: "/getPotentialOverstockLineGraphData",
            method: 'POST',
            data: payload
        })
    }),
    getInactiveInventoryData: builder.mutation({
        query: (payload:any)=>({
            url:"/getInactiveInventoryData",
            method:'POST',
            data:payload
        })
    }),
    getInactiveInventoryWaterfallData: builder.mutation({
        query: (payload:any)=>({
            url: "/getInactiveInventoryWaterfallData",
            method: 'POST',
            data: payload
        })
    }),
    getForecastRebalancingData: builder.mutation({
        query: (payload:any)=>({
            url: "/getForecastRebalancingData",
            method: 'POST',
            data: payload
        })
    }),
    getInactiveInventoryPlantLevelData: builder.mutation({
        query: (payload:any)=>({
            url:"/getInactiveInventoryPlantLevelData",
            method: 'POST',
            data: payload,
        })
    }),
    getInventoryHajocaDemoChanges: builder.mutation({
        query: (payload:any)=>({
            url:"/getInventoryHajocaDemoChanges",
            method: 'POST',
            data: payload,
        })
    }),
    getPerformaceMatricsTable: builder.mutation({
        query: (payload:any)=>({
            url:"/getPerformaceMatricsTable",
            method: 'POST',
            data: payload,
        })
    }),
    getPerformaceMatricsChartData: builder.mutation({
        query: (payload:any)=>({
            url:"/getPerformaceMatricsChartData",
            method: 'POST',
            data: payload,
        })
    }),
    getPerformaceMatricsFilters: builder.mutation({
        query: (payload:any)=>({
            url:"/getPerformaceMatricsFilters",
            method: 'POST',
            data: payload,
        })
    }),
  }),
});

export const {
    useGetInventoryFiltersMutation,
    useGetDemandInventoryLineGraphDataMutation,
    useGetForecastRebalancingDataMutation,
    useGetInactiveInventoryDataMutation,
    useGetInactiveInventoryWaterfallDataMutation,
    useGetPotentialOverstockDataMutation,
    useGetPotentialOverstockLineGraphDataMutation,
    useGetStockoutDataMutation,
    useGetInactiveInventoryPlantLevelDataMutation,
    useGetInventoryHajocaDemoChangesMutation,
    useGetPerformaceMatricsTableMutation,
    useGetPerformaceMatricsChartDataMutation,
    useGetPerformaceMatricsFiltersMutation
} = inventoryApi;
